<template>
  <div style="padding: 0 15px;" class="mall-course">
    <router-link class="f messages" style="color: black" to="/mall/wechatMall/index?clearTabNav=true">
    <span class="icon font_family icon-book" style="font-size: 28px;margin-right: 5px"></span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MallCourse',

  methods: {

  }
}
</script>

<style scoped>
.mall-course {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  line-height: 10px;
}

.mall-course.is-active {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/comm/MallCourse/index.vue